import { Link, useLocation } from "react-router-dom";
import { Scale, X } from "lucide-react";
import { useShortlist } from "./ShortlistContext";

export function ShortlistDock() {
  const { providerIds, compareHref, clear } = useShortlist();
  const location = useLocation();
  if (
    providerIds.length === 0 ||
    location.pathname === "/jamfor" ||
    location.pathname.startsWith("/utforare/")
  )
    return null;

  return (
    <aside
      aria-label="Sparade utförarenheter"
      className="fixed inset-x-3 bottom-3 z-40 mx-auto flex max-w-xl items-center gap-3 rounded-2xl border border-brand-primary/20 bg-white p-3 shadow-2xl md:bottom-6"
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent text-brand-primary">
        <Scale className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-surface-900">
          {providerIds.length} av 3 sparade
        </p>
        <p className="text-xs text-surface-600">
          Sparas bara i din webbläsare.
        </p>
      </div>
      <Link
        to={compareHref}
        className="inline-flex min-h-11 items-center rounded-xl bg-brand-primary px-4 py-2 text-sm font-bold text-white hover:bg-brand-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
      >
        Jämför
      </Link>
      <button
        type="button"
        onClick={clear}
        aria-label="Rensa sparade utförarenheter"
        className="inline-flex h-11 w-11 items-center justify-center rounded-xl text-surface-500 hover:bg-surface-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary"
      >
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </aside>
  );
}
